import { DomainId } from '#graphql-operations'
import type { Langcode } from '#nuxt-language-negotiation/config'

const DOMAIN_HOST_PATTERNS: Partial<Record<DomainId, RegExp[]>> = {
  [DomainId.eyz]: [/^(www\.|staging\.)?eyz\.swiss$/i, /^eyz\.ddev\.site$/i],
  [DomainId.rapperswil_zuerichsee_ch]: [
    /^(www\.|staging\.)?rapperswil-zuerichsee\.ch$/i,
    /^rapperswil\.ddev\.site$/i,
  ],
}

/**
 * Valid languages per domain, mirroring DomainHelper::getValidLanguagesForDomain().
 */
const DOMAIN_LANGUAGES: Partial<Record<DomainId, Langcode[]>> = {
  [DomainId.eyz]: ['de'],
  [DomainId.rapperswil_zuerichsee_ch]: ['de'],
}

const DEFAULT_LANGUAGES: Langcode[] = ['de', 'en', 'fr', 'it', 'es']

export function getDomainIdForHost(host: string): DomainId | null {
  const hostname = (host.split(':')[0] ?? host).toLowerCase()

  for (const [domainId, patterns] of Object.entries(DOMAIN_HOST_PATTERNS)) {
    if (patterns?.some((pattern) => pattern.test(hostname))) {
      return domainId as DomainId
    }
  }

  return null
}

export function getValidLanguagesForHost(host: string): Langcode[] {
  const domainId = getDomainIdForHost(host)

  if (domainId && DOMAIN_LANGUAGES[domainId]) {
    return DOMAIN_LANGUAGES[domainId]!
  }

  return DEFAULT_LANGUAGES
}
